

























import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class InputUpload extends Vue {
  @Prop() title!: string

  @Prop() acceptedTypes!: string

  @Prop({ type: Boolean, default: false }) multiple!: boolean

  @Emit()
  change(event: InputEvent) {
    return event
  }
}
